// @flow

import * as React from 'react';
import classNames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay/compat';

const SIZES = {
  MICRO: 16,
  SMALL: 20,
  REGULAR: 26,
  LARGE: 32
};

export type JobPresenterUser = {
  name: string,
  avatarUrl: string
};

type User = {
  +name: ?string,
  +avatar: {
    +url: string
  }
};

type Props = {
  +user: User,
  size?: $Keys<typeof SIZES>,
  className?: string,
  style?: Object,
  suppressAltText?: boolean
};

export default class UserAvatar extends React.PureComponent<Props> {
  // I'm so sorry, please delete this method as soon as you can
  static convertUserFromJobPresenter({ name, avatarUrl }: JobPresenterUser): User {
    return {
      name,
      avatar: {
        url: avatarUrl
      }
    };
  }

  render() {
    const size = this.props.size ? SIZES[this.props.size] : null;
    const style = {
      ...this.props.style,
      height: size || this.props.style?.height,
      width: size || this.props.style?.width
    };

    return (
      <img
        src={this.props.user.avatar.url}
        className={classNames("circle", this.props.className)}
        alt={this.altText}
        title={this.altText}
        style={style}
      />
    );
  }

  get altText() {
    if (this.props.suppressAltText) {
      return "";
    }

    return this.props.user.name;
  }
}

export const UserAvatarRelay = createFragmentContainer(UserAvatar, {
  user: graphql`
    fragment UserAvatar_user on User {
      name
      avatar {
        url
      }
    }
  `
});
